import { inject, Injectable } from '@angular/core';

import { AddAdminRequest, AddRoleRequest, UpdateRoleRequest } from '../shared/models/roles.model';
import { CommonAPIService } from './common.service';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  private commonService = inject(CommonAPIService);

  hierarchyList: Subject<string> = new BehaviorSubject<string>('');
  roleList: Subject<string> = new BehaviorSubject<string>('');
  // Tab passed to the Add/Edit Tab modal (null => add new tab).
  permissionModalTab: any = null;
  // Emits after the tab catalog changes (add/edit/delete) for live refresh.
  permissionCatalogChanged: Subject<boolean> = new Subject<boolean>();
  addSupervisorSupportType: number;
  supportIndex: number;
  rolesData;
  HierarchyUsersList;
  filterHierarchyUsersList;
  hierarchyData;
  addSupervisorSupportManager;
  hierarchyAllList;
  allSitesList;
  managerAndOperatorList;
  dwHierarchyUsersList: any[] = [];
  addSupervisorSupportSelectedManager: any;
  addSupervisorSupportSelectedSuperVisor: any;
  constructor() { }

  getRoles() {
    return this.commonService.get('/roles');
  }

  // Tab/feature permissions for the logged-in user's role
  getTabPermissions() {
    return this.commonService.get('/roles/tab-permissions');
  }

  // Dynamic tab/permission catalog (list of tabs stored in the DB)
  getPermissionsCatalog() {
    return this.commonService.get('/permissions');
  }

  addPermissionTab(params: { label: string }) {
    return this.commonService.post('/permissions', params);
  }

  updatePermissionTab(id: string, params: { label: string }) {
    return this.commonService.put('/permissions', params, id);
  }

  deletePermissionTab(id: string) {
    return this.commonService.delete('/permissions/' + id);
  }

  // Client portal mail relay allowlists (caller IPs + attachment hosts)
  getClientPortalSettings() {
    return this.commonService.get('/client-portal/settings');
  }

  updateClientPortalSettings(params: { email_ips: string[]; attachment_hosts: string[] }) {
    return this.commonService.put('/client-portal/settings', params);
  }

  addRoles(params: AddRoleRequest) {
    return this.commonService.post('/roles', params);
  }

  deleteRoles(id: number) {
    return this.commonService.delete('/roles/' + id);
  }

  updateRoles(params: UpdateRoleRequest) {
    return this.commonService.post('/roles', params);
  }

  addAdmins(id: number, params: AddAdminRequest) {
    return this.commonService.put('/roles/' + id, params);
  }

  getHierarchyUsers() {
    return this.commonService.get('/hierarchy_user');
  }

  addUpdateHierarchyList(data) {
    return this.commonService.post('/add_update/hierarchy', data);
  }

  hierarchyTimeChange(data) {
    return this.commonService.post('/hierarchy/time_change', data);
  }

  getHierarchyList() {
    return this.commonService.get('/get_hierarchy');
  }

  // Users + saved hierarchy in one call; the two used to be chained.
  getHierarchyInit() {
    return this.commonService.get('/hierarchy_init');
  }

  getAllSites() {
    return this.commonService.get('/sites/all/list');
  }

  deleteHierarchy(id: number) {
    return this.commonService.delete('/hierarchy/' + id);
  }

  updateUserParentUser(data) {
    return this.commonService.post('/update_user/parent_user', data);
  }

  updateSiteParentUser(data) {
    return this.commonService.post('/sites/parent_id', data);
  }
}
